import { UITimerStore } from 'common/stores/UITimerStore';
import { ITimerStrategy } from '.';
import { DisplayConfigType } from '../../config';
import { TIMERS } from 'common/stores/constants/timers.constant';
import { MraidStore } from 'common/stores/MraidStore';

export class CloseButtonTimer implements ITimerStrategy {
  constructor(
    private mraidStore: MraidStore,
    private adContext: AdContext,
    private formatConfig: DisplayConfigType
  ) {}

  isRunnable(): boolean {
    return typeof this.formatConfig?.closeBtn?.displayAfter !== 'undefined';
  }

  run(uiTimerStore: UITimerStore): void {
    uiTimerStore.addTimer(
      TIMERS.CLOSE_BUTTON_TIMER,
      this.formatConfig?.closeBtn?.displayAfter * 1000
    );

    uiTimerStore.get(TIMERS.CLOSE_BUTTON_TIMER)!.resume();

    if (
      this.adContext.adUnitType === 'header_ad' &&
      !this.mraidStore.isDefaultMinimized
    ) {
      uiTimerStore.get(TIMERS.CLOSE_BUTTON_TIMER)!.finish();
    }
  }
}
